import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { CustomInput } from '@kiper/ui';
import colors from '@kiper/theme/colors';
import { HEX_COLOR } from '../../../../utils/validateGeneratorForm';
import * as S from './styles';

const ColorField = ({ name, label, value, error, onChange }) => {
  const [t] = useTranslation('personalized-invite');

  const handlePickerChange = event =>
    onChange(name, event.target.value.toUpperCase());

  return (
    <S.Wrapper>
      <S.ColorPicker
        type="color"
        aria-label={t('generator.fields.color-picker', { field: label })}
        value={HEX_COLOR.test(value) ? value : colors.porterPrimary}
        onChange={handlePickerChange}
      />
      <S.InputWrapper>
        <CustomInput
          name={name}
          label={label}
          value={value}
          error={error}
          onChange={onChange}
          placeholder="#RRGGBB"
          maxLength={7}
          required
        />
      </S.InputWrapper>
    </S.Wrapper>
  );
};

ColorField.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  value: propTypes.string,
  error: propTypes.string,
  onChange: propTypes.func.isRequired,
};

ColorField.defaultProps = {
  value: '',
  error: '',
};

export default ColorField;
